export const INPUT_BOX_MARGIN = 15
